class @App.Components.VideoSearch
  constructor: ->
    @el = $('#video_search')
    @form = @el.find('.search-form form')
    @q = @el.find('input[name="q"]')

    @form.parsley().subscribe 'parsley:form:validate', (form_instance) =>
      if form_instance.isValid()
        $(document).trigger
          type: 'App::Components::VideoSearch::search_submit',
          search_query: @q.val()

    bindAjaxCallbacks('.search-form, [data-pagination="videos"]')

    $(document).trigger 'App::Components::VideoSearch::search_ready'

  # Function signatures are through @rails/ujs and are defined in:
  # https://guides.rubyonrails.org/working_with_javascript_in_rails.html#rails-ujs-event-handlers
  bindAjaxCallbacks = (scope) ->
    $(document).on 'ajax:beforeSend', scope, (e) ->
      $(document).trigger 'App::Components::VideoSearch::before_send'

    $(document).on 'ajax:complete', scope, (e) ->
      $(document).trigger 'App::Components::VideoSearch::complete'

    $(document).on 'ajax:success', scope, (e) ->
      # Check if jQuery has wrapped the rails-ujs event.
      event = if e.originalEvent? then e.originalEvent else e
      data = event.detail[0]
      $(document).trigger
        type: 'App::Components::VideoSearch::success'
        videos: data.videos
        search_query: data.q
        page: data.page
        page_count: data.page_count
